import React from 'react'
import { useSelector } from 'react-redux'

import { Modal, Typography, Icon } from 'antd'

const Loading = function () {
  const show = useSelector((store) => store.loading.show)
  const loadingMessage = useSelector((store) => store.loading.message)
  return (
    <Modal visible={show} footer={null} header={null} closable={false}>
      <div style={{ justifyContent: 'center', alignItems: 'center', display: 'flex' }}>
        <Icon spin type="loading" style={{ fontSize: 50, color: '#E21D45' }} />
      </div>
      <div style={{ justifyContent: 'center', alignItems: 'center', display: 'flex' }}>
        <Typography.Title level={4}>Carregando...</Typography.Title>
      </div>
      <div style={{ justifyContent: 'center', alignItems: 'center', display: 'flex' }}>
        <Typography.Text>{loadingMessage}</Typography.Text>
      </div>
    </Modal>
  )
}

export default Loading
